import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationBuyingWishApiService } from './organization-buying-wish-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationBuyingWishApiService extends GeneratedOrganizationBuyingWishApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
